import { useState } from 'react';
import { getFormUrl } from '@/utils';

export default function BrandStory() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="w-full lg:w-1/2">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20style%20reading%20room%20with%20cherry%20blossom%20view%20through%20large%20window%2C%20warm%20natural%20light%2C%20bookshelves%20filled%20with%20manga%2C%20cozy%20atmosphere%2C%20soft%20pink%20and%20cream%20interior%2C%20clean%20minimal%20Japanese%20aesthetic&width=800&height=600&seq=yuri-about-brand&orientation=landscape"
              alt="百合会品牌故事"
              className="w-full rounded-xl object-cover"
            />
          </div>
          <div className="w-full lg:w-1/2">
            <span className="inline-block px-3 py-1.5 rounded-md text-xs font-medium bg-primary-100 text-primary-700 mb-4">
              品牌故事
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              关于百合会
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                百合会创立于2018年，由一群热爱百合文化的ACG爱好者发起。我们相信，女性之间的情感故事有其独特的魅力和深度，值得被更多人看见和欣赏。
              </p>
              <p>
                从最初的一个小型同好交流群，发展到如今拥有超过12万注册用户的大型社区，百合会始终秉持着<strong>开放、包容、热爱</strong>的核心理念，为每一位百合文化爱好者提供优质的阅读体验和交流环境。
              </p>
              <p>
                我们汇聚了来自全国各地的创作者和读者，共同构建了一个充满活力与温暖的百合文化生态。无论你是刚接触百合文化的新人，还是资深的百合作品鉴赏家，百合会都有属于你的一片天地。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}